export const mobileBreakpoint = 824;

export const xlImageBreakpoint = 1080;

// constants so that we can give direct width and height values
// to ImgIx
export type YellowDotsImage = { imageWidth: number; dotsWidth: number; dotsHeight: number };

export const YELLOW_DOTS_IMAGE_SIZES = {
  xl: { imageWidth: 383, dotsWidth: 124, dotsHeight: 92 } as YellowDotsImage,
  xxl: { imageWidth: 476, dotsWidth: 154, dotsHeight: 115 } as YellowDotsImage,
  heightWidthRatio: 429 / 476,
};

export const YES_I_CAN_IMAGE_SIZES = {
  xxlImageWidth: 477,
  xlImageWidth: 300,
  heightWidthRatio: (429 / 396) as number,
};
